export default __webpack_public_path__ + "static/media/background.f46fd1c2.png";